import type { IEmployeeRoleReference } from '@sharedInterfaces/IEmployee';
import store from '@store/store';

/**
 * Gets the primary role for an employee
 * Returns the role marked as primary, or falls back to the first role
 *
 * @param roles - Array of employee roles
 * @returns Primary role or first role, or null if no roles exist
 */
export function getPrimaryRole(roles: IEmployeeRoleReference[]): IEmployeeRoleReference | null {
    if (!roles || roles.length === 0) {
        return null;
    }

    // Get primary role ID from Redux store
    const state = store.getState();
    const primaryRoleId = state.employee.primaryRoleId;

    // Find primary role by ID
    if (primaryRoleId) {
        const primaryRole = roles.find((role) => role.id === primaryRoleId);
        if (primaryRole) {
            return primaryRole;
        }
    }

    // Fallback to first role (alphabetically sorted)
    const sortedRoles = [...roles].sort((a, b) => a.title.localeCompare(b.title));
    return sortedRoles[0];
}

/**
 * Gets the primary role title for display purposes
 *
 * @param roles - Array of employee roles
 * @returns Primary role title or empty string
 */
export function getPrimaryRoleTitle(roles: IEmployeeRoleReference[]): string {
    const primaryRole = getPrimaryRole(roles);
    return primaryRole?.title || '';
}
